import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class AdminNavigationService {

    titleId = signal<string>('admin-navigation.title');
}